import { shopsUseCase } from '../../../../core/usecases'
import { ref } from '@vue/composition-api'

const joinedShopsStaging = [
    '1wET9GytJveaJXRWL4Rn',
    '21oQM2Zi0jxTWy05OYXP',
    '2rVRNgPX9onSoW3DKzuv',
    '34MBPn6PJOnn6J4y9Jz7'
]
const joinedShopsProd = [
    '2xwZqhLLRGMIO2pnJzdM',
    'ulqSb6BMq5NK4KyN4PkE',
    '5j6VZnuZOsOWhaGMIkyX',
    'HDd4N4uDVQTsFbupCrSr',
    'TXNj5XsG0vsu9PFtcMW8',
    'W2iQwF91kW78bDzaHTFq',
    'H0EWtYf1PDLzQV2TQQxw',
    'ZDJbhd0l37PRdSE53yxU',
    'BqLpEaiqYV68idkI4nG4',
    'bMGHhz6w3RKejfM5VDSq',
    'fEcPCQ7juB7S05pGNbXg',
    'Qz9vrWp3hRgx6C3i6XVA',
    'i66FEinHFH4DpbX1oA8n',
    'qEXGMQstAsJWb8mXtGbp',
    'aHbiPID1tWTZx1HmARnB',
    'BvBEHJDUa8F6IHF89uBh',
    'qEW9o3jy1aZ0S8YmHe1P',
    'RWWUhJ0s6vwMNuiSaJI0',
    'uazCchcrm0jlwG2WlWD7',
    'Da0ddyysBviP4LJco094',
    'hwXGIXjRDAca6DK94dLe',
    'ATS65q5JiVw99hhvyXvQ',
    'oFOWxUTQ2BFD6r4HL8nB',
    'X9MpyRRrQ8M1xmiJbdMf',
    '1SZQoiPtesNXRxEFxI8A',
    'EFQ4ElEppcZ1x9JbCXgK',
    'SIhTzu2DqJDNqFy3pgo4',
    'qFQeprn8OtmfRoEoofSq',
    'CpecBd0JNgxLBZ8nkbiP',
    'X4vGnATQuEFzlssZ336t',
    'X9HC9tBcbLdAvuctlJ8m',
    '6WgyN9jmqOVz9wk6Qtg8',
    'N53oVllXWoCEW8eKnibD',
    'bu3vgSgU6irwHFBYbXlI',
    'Qwcp1ZGYXlSjBLTzpSEo',
]
const joinedShops = process.env.NODE_ENV === 'production' ? joinedShopsProd : joinedShopsStaging

const useJoinedShops = () => {
    const joined = ref(null)
    const getJoinedShops = async ()  => {
        joined.value = [...await shopsUseCase.getShopsByIds(joinedShops, joinedShops.length)]
    }
    return {
        joined,
        getJoinedShops
    }
}

export default useJoinedShops;